module.exports = __webpack_public_path__ + "static/media/vacation5.6244211d.png";